<template>
  <div>
    <div class="case_div">
      <img class="home_banner" src="../../static/img/关于我们顶图.png" />
      <!-- <img class="home_banner" src="../../static/img/关于顶部图.png" />
      <div class="div_top_title">
        <p>全方位的一站式安全保卫服务</p>
        <p class="p_title_sub">PROFESSIONAL TEAM</p>
      </div> -->
    </div>
    <div id="brand">
      <el-row class="div-1-top">
        <el-col :md="12">
          <div class="div-1">
            <p>宁波宏邦保安服务<br />有限公司</p>
          </div>
        </el-col>
        <el-col :md="12">
          <div class="div-2">
            <p>
              宁波宏邦保安服务有限公司是经浙江省公安厅批准，宁波市公安局监管，并于工商行政管理机构合法注册，从事现代安防业的综合服务供应商；是宁波市一家新型的专业化、规范化、科学化、现代化的服务型企业。
            </p>
            <p>
              我们是具有独立法人地位的专业人防与技防相结合的服务企业，提供人防、物防、技防、联网报警、保安培训、非武装押运等安防相关的一站式服务。在上级公安机关的正确领导下和社会各界及广大客户的支持下，公司规模不断扩大，业务及保安从业人员不断壮大，使公司进入了规范化、科学化的管理模式。
            </p>
            <p v-show="showTotal">
              公司专业的服务资质和经验，能在最短的时间里，为客户组建服务队伍，并通过有系统的培训及标准化的规章流程，使工作有序展开。宏邦保安自创立以来，在全体员工的不懈努力下，迅速发展，规模不断扩大。现宏邦保安正以求真务实、锐意进取的精神，抓住新机遇，迎接新挑战，努力实现新一轮腾飞。宏邦保安牢记“铸安全盾牌，立服务口碑”的立业宗旨，秉承“专业、
              专注、
              专心”的经营理念和“安全万无一失，服务永无止境”的服务理念，恪守“从管理要素质，从素质夺信誉，从信誉赢客户，从服务创效益”的质量管理方针，
              严格管理，优质服务，积极探索，
            </p>
            <div class="show-total-div" @click="showTotalFun(showTotal)">
              <!-- <p @click="showTotalFun(showTotal)">{{showTotal?'收起':'查看全文'}}</p> -->
              <img v-show="!showTotal" src="../../static/img/ic_showtotal_1.png"/>
              <img v-show="showTotal" src="../../static/img/ic_showtotal_2.png"/>
            </div>
          </div>
          <div class="div-1-tip">
            <p>
              公司已通过<br />SO14001:2015 环境管理体系认证<br />ISO9001:2015
              质量管理体系认证<br />BSOHSAS18001:2007 职业健康安全管理体系认证
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="div-3-top" id="wenhua">
      <div class="div-3-img-div">
        <img src="../../static/img/ic_about_1.png" />
        <img src="../../static/img/ic_about_2.png" />
        <img src="../../static/img/ic_about_3.png" />
      </div>
      <div class="div-3-txt-div">
        <p class="title">力争成为更专业、更具市场竞争力的<br />安保服务机构</p>
        <div class="div-3-sub-txt-div">
          <p class="div-3-sub-title">企业理念</p>
          <p class="div-3-sub-content">提供更高规格、更专业、更高品质的服务</p>
        </div>
        <div class="div-3-sub-txt-div">
          <p class="div-3-sub-title">市场定位</p>
          <p class="div-3-sub-content">
            向社会团体及个人提供更专业、更精细、更全面和更可靠的安全保卫服务
          </p>
        </div>
        <div class="div-3-sub-txt-div">
          <p class="div-3-sub-title">企业愿景</p>
          <p class="div-3-sub-content">
            力争成为更专业、更具市场竞争力的安保服务机构
          </p>
        </div>
      </div>
    </div>
    <div class="div-4-top" id="tuandui" 
      >
      <el-row
      data-aos="fade-up"
      data-aos-anchor-placement="top-bottom"
      data-aos-duration="2000"
      data-aos-id="super-duper"
      >
        <el-col :md="12">
          <div class="div-4-left-div">
            <p class="title">专业团队，全方位的一站式<br />安全保卫服务</p>
            <div class="num-div">
              <img src="../../static/img/ic_about_4.png" />
              <div>
                <span class="num"
                  ><countTo
                    ref="mynum"
                    :startVal="0"
                    :endVal="2500"
                    :duration="3000"
                    :separator="null"
                  ></countTo
                  ><span class="simple_end">+</span></span
                >
                <p class="num-tip">安保人员</p>
              </div>
            </div>
            <div class="num-div">
              <img src="../../static/img/ic_about_5.png" />
              <div>
                <span class="num"
                  ><countTo
                    ref="mynum1"
                    :startVal="0"
                    :endVal="50"
                    :duration="3000"
                    :separator="null"
                  ></countTo
                  ><span class="simple_end2">%</span></span
                >
                <p class="num-tip">管理人员为部队退役军人</p>
              </div>
            </div>
            <div class="num-div">
              <img src="../../static/img/ic_about_6.png" />
              <div>
                <span class="num"
                  ><countTo
                    ref="mynum2"
                    :startVal="0"
                    :endVal="200"
                    :duration="3000"
                    :separator="null"
                  ></countTo
                  ><span class="simple_end">+</span></span
                >
                <p class="num-tip">合作单位</p>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :md="12">
          <div class="div-4-right-div">
            <p class="title">
              宏邦保安服务有限公司拥有安保从业人员 2500
              余人，集人防与技防于一体，
              并取得省公安厅颁发的保安服务许可证、保安培训许可证的保安服务公司，公司现有大型合作单位
              200 余家，遍及长三角地区。公司 50%
              的管理人员为部队转业军人。公司用军事化标准来管理团队，以军人的标准来要求每一位保安人员。
            </p>
            <el-collapse v-model="activeName1" accordion class="collapse-div">
              <el-collapse-item title="安保人员" name="1">
                <template slot="title">安保人员<i :class="judgeActive('1')!==-1?'downArrow2':'downArrow1'"></i></template>
                <p class="txt-content">
                  保安队员均经过专业的培训，熟悉消防、安保监控系统，配备统一的保安服务装，熟知治安防范措施。所有保安队员采取军事化管理，定期进行培训，可根据客户要求安排统一驻守，遇紧急任务时随叫随到。
                </p>
              </el-collapse-item>
              <el-collapse-item title="专业管理人员" name="2">
                <template slot="title">专业管理人员<i :class="judgeActive('2')!==-1?'downArrow2':'downArrow1'"></i></template>
                <p class="txt-content">
                  合理调度安全保卫工作的运行，对客户需求做出快速动态反应，灵活的管理方式适应不同的客户需求。利用专业的安保运作体系及专业的安保服务人才为客户提供全方位的一站式的安全保卫服务。
                </p>
              </el-collapse-item>
              <el-collapse-item title="专业技术人员" name="3">
                <template slot="title">专业技术人员<i :class="judgeActive('3')!==-1?'downArrow2':'downArrow1'"></i></template>
                <p class="txt-content">
                  为配合专业管理人员进行后续作业，公司配备实际操作经验丰富的专业技术人员以及持证上岗的特种设备操作人员，按个别客户不同需要，提供多元化安全保卫服务。
                </p>
              </el-collapse-item>
              <el-collapse-item title="专业师资团队" name="4">
                <template slot="title">专业师资团队<i :class="judgeActive('4')!==-1?'downArrow2':'downArrow1'"></i></template>
                <p class="txt-content">
                  培训中心拥有一支由具有高、中级职称、从事安全保卫工作多年的教师和富于一线实战经验的资深教官组成的30多人教师团队，彰显师资团队的雄厚与专业实力。培训中心坚持因材施教，突出实效性，严谨教学、勇于创新的办学精神，为企业和社会输送具有全面业务能力和专业技能的优秀保卫干部和安保人员。
                </p>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="div-5-top" id="honor">
      <p class="title">携共进，创新风</p>
      <div class="middle_banner">
        <div class="swiper-button-prev swiper-button-prev1"></div>
        <div class="swiper-container mySwiper mySwiper1">
          <div class="swiper-wrapper">
            <!-- Slides -->
            <!-- <div class="swiper-slide" v-for="(item, index) in List" :key="index"> -->
            <div
              class="swiper-slide"
              v-for="(item, index) in BookList1"
              :key="index"
            >
              <!-- <img src="../../static/img/3A证书.png" /> -->
              <img class="book1_img" :src="item.img" />
              <p class="txt-title">{{item.name}}</p>
              <p class="txt-year">{{item.yname}}</p>
              <p class="txt-dot">.</p>
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next1"></div>
        <div class="myswiper-line"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ShowLine from "../components/ShowLine.vue";
import aboutView from "../components/view/AboutView";
import countTo from "vue-count-to";
export default {
  components: {
    ShowLine,
    aboutView,
    countTo,
  },
  data() {
    return {
      path: "brand",
      activeName1: "1",
      Detail: [],
      BookList1: [],
      showTotal:false,
    };
  },
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    if(param){
      this.path = param;
      console.log("param:" + param);
      this.navtoPartPath(this.path);
    }else{
      window.scrollTo(0, 0);
    }
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
      if(param){
        this.path = param;
        console.log("param:" + param);
        this.navtoPartPath(this.path);
      }else{
        window.scrollTo(0, 0);
      }
    },
    //监听轮播数据变化后再创建实例
    BookList1() {
      this.$nextTick(() => {
        new Swiper(".mySwiper1", {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          // autoplay: {
          //   disableOnInteraction: false,
          // },
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
        });
      });
    },
  },
  methods: {
    Init() {
      this.getDetail();
      this.getBookList1();
    },
    navtoPartPath(path) {
      setTimeout(() => {
        document.getElementById(path).scrollIntoView();
      }, 500);
    },
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    judgeActive(data){
      return  this.activeName1.indexOf(data)
    },
    getBookList1() {
      this.$axios.get("api/aaabanner/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.BookList1 = response.data.page.list;
          }
        }.bind(this)
      );
    },
    
    getDetail() {
      this.$axios.get("api/contacts/company").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.Detail = response.data.data;
          }
        }.bind(this)
      );
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    //显示全文本
    showTotalFun(show){
      this.showTotal=!show;
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 50%;
  height: 100%;
  left: 15%;
  top: 0;
  color: white;
  font-size: 5rem;
  font-family: bold;
  margin-bottom: 0;

  p {
    margin-bottom: 0;
    user-select: none;
  }

  .p_title_sub {
    font-size: 3.8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    line-height: 1;
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

.middle_banner {
  margin-top:5rem;
  position:relative;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-content: center;
  align-items: flex-end;
}

.myswiper-line{
  position:absolute;
  background:var(--COLORE004192);
  height:1px;
  width:95%;
  margin-left: 0;
  margin-right: 0;
  bottom: 1rem;
  left:50%;
  right:50%;
  transform:translate(-50%,-50%);
}

.swiper-button-prev {
  background-image: url('../../static/img/oldbannerleft.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
  //position: absolute;
  width: 5rem;
  height: 5rem;
  margin-left: 0;
  outline: none;
  bottom: -1rem;
    top: unset;
}

.swiper-button-prev:hover {
  background-image: url('../../static/img/oldbannerlefthover.png');
}

.swiper-button-next {
  background-image: url('../../static/img/oldbannerright.png');
  color: transparent;
  background-repeat: no-repeat;
  background-size: cover;
  //position: absolute;
  width: 5rem;
  height: 5rem;
  margin-right: 0;
  outline: none;
  bottom: -1rem;
    top: unset;
}

.swiper-button-next:hover {
  background-image: url('../../static/img/oldbannerrighthover.png');
}

.swiper-slide {
  //width: 20%;
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  

  img {
    width: 100%;
    height: 40rem;
    object-fit: contain;
    transition: 300ms;
    transform: scale(0.8);
  }
  .txt-year{
    transition: 300ms;
    transform: scale(0.8);
    margin-bottom:0;
    font-size:2.4rem;
    color:var(--COLORE004192);
    font-family: DIN-Bold;
    margin-bottom:0;
  }
  .txt-title{
    font-size:2.4rem;
    color:transparent;
    margin:5rem 0;
    
  }
  .txt-dot{
    width: auto;
    line-height: 1.2;
    font-size: 4rem;
    margin-bottom: 0;
    color:var(--COLORE004192);
  }
}
.swiper-slide-active, .swiper-slide-duplicate-active {
  img{
    transform: scale(1);
  }
  .txt-title{
    color:var(--textBlue);
  }
  .txt-year{
    transform: scale(1);
  }
}
.swiper-slide-prev{
  align-items: flex-end;
  .txt-title{
    margin-right:5rem;
  }
  .txt-year{
    margin-right:5rem;
  }
  .txt-dot{
    margin-right:7.5rem;
  }
}
.swiper-slide-next{
  align-items: flex-start;
  .txt-title{
    margin-left:5rem;
  }
  .txt-year{
    margin-left:5rem;
  }
  .txt-dot{
    margin-left:7.5rem;
  }
}


.div-1-top {
  padding: 14rem 34rem;
  background-color: var(--COLOREF8);
  background-image: url('../../static/img/关于我们bg1.png');
  background-repeat: no-repeat;
  background-position: left, center;
}

.div-1 {
  color: var(--COLORE17);
  font-size: 2.4rem;
  font-family: bold;
}

.div-2 {
  color: var(--COLORE17);
  font-size: 1.6rem;
  line-height:1.77;
}
.show-total-div{
  cursor pointer;
  img{
    height:1.6rem;
  }
}
.div-1-tip {
  margin-top:10rem;
  background: var(--COLORE182347);
  padding: 2.4rem 3rem;
  color: white;
  max-width: 48rem;
  border-radius: 6px;

  p {
    font-size: 1.6rem;
    font-family: light;
  }
}

.div-3-top {
  flex-direction: column;
  display: flex;
  padding: 16rem 0;
  height: 83rem;
  background-image: url('../../static/img/关于我们bg2.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  background-origin: border-box;
  position: relative;
}

.div-3-img-div {
  bottom: 15rem;
  position: absolute;
  width: 9rem;
  align-self: center;

  img {
    margin-bottom: 4rem;
    height: auto;
    width: 100%;
  }
}

.div-3-txt-div {
  align-self: flex-end;
  width: 40%;
  color: white;
  font-family: bold;
  font-size: 3rem;

  .title {
  }

  .div-3-sub-txt-div {
    margin-top: 6rem;
    width: 50%;

    .div-3-sub-title {
      font-size: 1.6rem;
      color: var(--textBlue);
    }

    .div-3-sub-content {
      font-size: 1.6rem;
      font-family: light;
    }
  }
}

.div-4-top {
  padding: 14rem 34rem;
  flex-direction: column;
  display: flex;
  height: 83rem;
  background-image: url('../../static/img/关于我们bg3.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  background-origin: border-box;
  position: relative;

  .div-4-left-div {
    .title {
      font-size: 3rem;
      font-family: bold;
      color: var(--COLORE17);
      margin-bottom: 11rem;
    }

    .num-div {
      display: flex;
      margin-top: 4rem;
    }

    .num {
      font-size: 4rem;
      color: var(--textBlue);
      font-family: DIN-Bold;
    }

    .simple_end {
      color: var(--textBlue);
      font-size: 2rem;
      font-family: DIN-Bold;
      vertical-align: super;
    }

    .simple_end2 {
      color: var(--textBlue);
      font-size: 4rem;
      font-family: DIN-Bold;
    }

    .num-tip {
      font-size: 1.6rem;
    }

    img {
      margin-right: 3rem;
      height: 8rem;
      width: 8rem;
    }
  }

  .div-4-right-div {
    .title {
      font-size: 1.6rem;
      color: var(--COLORE17);
      margin-bottom: 11rem;
      line-height: 1.77;
    }
    >>>.el-collapse-item__arrow{
  display: none;
}
//下方两个是打开和关闭的图标
.downArrow1{
  display: inline-block;
  width: 13px;
  height: 16px;
  background-image: url('../../static/img/ic_collape_1.png');
  background-repeat: no-repeat;
}
.downArrow2{
  display: inline-block;
  width: 13px;
  height: 16px;
  background-image: url('../../static/img/ic_collape_2.png');
  background-repeat: no-repeat;
}
//头部穿透，让头部内容在两端，本身固有属性是flex
 >>> .el-collapse-item__header {
        justify-content: space-between;
       
      }

    /deep/ .el-collapse-item__header.is-active {
      color: var(--textBlue);
      padding-bottom: 1rem;
    }

    /deep/ .el-collapse-item__header.focusing:focus:not(:hover) {
      color: var(--textBlue);
    }

    /deep/ .el-collapse-item__header {
      color: var(--COLORE17);
      font-family: medium;
      font-size: 2rem;
      padding-bottom: 2rem;
      padding-top: 1rem;
      background-color: transparent;
    }

    /deep/ .el-collapse-item__wrap {
      background-color: transparent;
    }

    /deep/ .el-collapse-item__content {
      font-size: 1.6rem;
      color: var(--COLORE67);
    }
  }
}

.div-5-top {
  padding:11rem;
  background-image: url('../../static/img/关于我们bg4.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom;
  background-origin: border-box;

  .title {
    margin-left:24rem;
    font-size: 3rem;
    font-family: bold;
    color: var(--COLORE17);
  }
}
@media screen and (max-width: 1200px) {
  .div-1-top{
    padding: 10rem 1rem;
  }
  .div-3-txt-div{
    .div-3-sub-txt-div{
      width:100%;
      margin-top: 1rem;
    }
  }
  .div-3-img-div{
    width:7rem;
    bottom: 8rem;
    img{
      margin-bottom: 6rem;
    }
  }
  .div-4-top{
    padding:14rem 1rem;
    height:auto;
  }
  .div-5-top{
    padding:11rem 1rem;
    .title{
      margin-left: 1rem
    }
  }
  .swiper-slide{
    .txt-title{
      font-size:1rem;
    }
  }
  .myswiper-line{
    width:85%;
  }
  
}
</style>
